import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_SRC } from "@/lib/site";

export default function AvisoPrivacidad() {
  return (
    <div className="min-h-screen bg-white font-body text-[#2E3338] antialiased">
      <header className="border-b border-[#1BA8E0]/15 bg-white/90 backdrop-blur-xl">
        <div className="mx-auto flex h-[72px] max-w-4xl items-center justify-between px-5 sm:px-8">
          <Link to="/" data-testid="aviso-logo-link" aria-label="Volver al inicio de Seguclick">
            <img src={LOGO_SRC} alt="Seguclick — agencia de seguros familiar" className="h-9 w-auto" />
          </Link>
          <Link
            to="/"
            data-testid="aviso-volver-link"
            className="inline-flex items-center gap-2 rounded-full border-2 border-[#1BA8E0] px-5 py-2 font-display text-sm font-semibold text-[#1BA8E0] transition-colors hover:bg-[#E8F6FD]"
          >
            <ArrowLeft className="h-4 w-4" />
            Volver al inicio
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-5 py-16 sm:px-8 sm:py-20" data-testid="aviso-contenido">
        <h1 className="font-display text-3xl font-bold tracking-tight text-[#0C5F8A] sm:text-4xl">
          Aviso de Privacidad
        </h1>
        <p className="mt-4 text-sm text-[#2E3338]/60">Última actualización: [PENDIENTE]</p>

        <div className="mt-10 space-y-8 text-base leading-relaxed text-[#2E3338]/80">
          <section>
            <h2 className="font-display text-xl font-semibold text-[#0C5F8A]">1. Responsable del tratamiento de tus datos</h2>
            <p className="mt-3">
              [PENDIENTE: Texto del Aviso de Privacidad. Aquí se indicará el nombre o razón social del
              responsable, su domicilio y los medios de contacto para ejercer derechos ARCO.]
            </p>
          </section>
          <section>
            <h2 className="font-display text-xl font-semibold text-[#0C5F8A]">2. Datos personales que recabamos</h2>
            <p className="mt-3">
              [PENDIENTE: Listado de los datos personales que se recaban a través del formulario de
              cotización y otros medios, por ejemplo: nombre, teléfono, correo electrónico y tipo de
              seguro de interés.]
            </p>
          </section>
          <section>
            <h2 className="font-display text-xl font-semibold text-[#0C5F8A]">3. Finalidades del tratamiento</h2>
            <p className="mt-3">
              [PENDIENTE: Descripción de las finalidades primarias (contactar al interesado, elaborar
              cotizaciones, dar seguimiento) y secundarias (estadísticas, mercadotecnia), en caso de
              que apliquen.]
            </p>
          </section>
          <section>
            <h2 className="font-display text-xl font-semibold text-[#0C5F8A]">4. Derechos ARCO y revocación del consentimiento</h2>
            <p className="mt-3">
              [PENDIENTE: Procedimiento para ejercer los derechos de Acceso, Rectificación, Cancelación
              y Oposición, así como para revocar el consentimiento.]
            </p>
          </section>
          <section>
            <h2 className="font-display text-xl font-semibold text-[#0C5F8A]">5. Cambios al Aviso de Privacidad</h2>
            <p className="mt-3">
              [PENDIENTE: Medio por el cual se notificarán los cambios al presente aviso de privacidad.]
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
